import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { WhoAmIVM } from '../../models';
import { ActivatedRoute } from '@angular/router';
import { ClientDashboardVM } from '../../models/ClientDashboardVM';
import { AccountService } from '../../services/account.service';

@Component({
    selector: 'home',
    templateUrl: './home.component.html'
})
export class HomeComponent extends BaseComponent implements OnInit {

    model: ClientDashboardVM = new ClientDashboardVM();

    constructor(
        private route: ActivatedRoute,
        private accService: AccountService
    ) {
        super(route);
        this.emitDisplayLoadingDialog(true);
        this.me = this.route.snapshot.data['whoAmI'];
        this.model = this.route.snapshot.data['accountData'] != null ? this.route.snapshot.data['accountData'] : this.model;
        this.accService.getDashboard(false)
            .subscribe((returnValue) => {
                this.model = returnValue;
                this.emitDisplayLoadingDialog(false);
            });
    }

    ngOnInit(): void {

    }

    onSessionDataChanged() {
        this.emitDisplayLoadingDialog(true);
        var self = this;
        self.model = new ClientDashboardVM();

        this.accService.getDashboard(false)
            .subscribe(
                returnValue => {
                    self.model = returnValue;
                    self.emitDisplayLoadingDialog(false);
                },
                error => { self.showDialog("Error loading information, please refresh page.", true); },
                () => { self.emitDisplayLoadingDialog(false); }
            );
    }

}
